import { sendUtagEvent } from '../../core/analytics/utag_events'
import { openLoader } from '../../elements/wait_loading/wait_loading'

const answers = {}
let remaining = 0

export function init() {
  fetchValues()
  setEvents()
  setUncompleted()
}

function fetchValues() {
  document.querySelectorAll('.question').forEach(block => {
    const question = block.querySelector('input').attributes['name'].value
    const answersNode = block.querySelector('.answer')
    const selected = answersNode.textContent?.split('|')
    answers[question] = selected.map(e => e.trim()).filter(e => e)

    answersNode.textContent = answers[question].join(', ')
    answersNode.classList.remove('hidden')
  })
}

function setEvents() {
  document.querySelectorAll('.question-header').forEach(el => el.addEventListener('click', handleHeaderClick))
  document
    .querySelectorAll('.question > fieldset input')
    .forEach(el => el.addEventListener('change', handleAnswerChange))
  document.querySelector('#preferences-anchor a')?.addEventListener('click', e => {
    e.preventDefault()
    e.stopPropagation()
    // TODO PY05032 No encontrados
    sendUtagEvent({
      data: {
        event_name: '',
        event_cat: 'manage my profile',
        event_act: 'holiday preferences',
        event_lbl: 'open preferences',
        force_cg: false,
        event_purpose: '',
        event_structure: '',
      },
    })
    const anchor = document.querySelector('#preferences-anchor')
    if (anchor.classList.contains('opened')) anchor.classList.remove('opened')
    else anchor.classList.add('opened')
  })
  document.querySelector('.submit-preferences')?.addEventListener('click', e => {
    // TODO PY05032 No encontrados
    sendUtagEvent({
      data: {
        event_name: '',
        event_cat: 'manage my profile',
        event_act: 'holiday preferences',
        event_lbl: 'submit preferences',
        force_cg: false,
        event_purpose: '',
        event_structure: '',
      },
    })
    openLoader()
  })
}

function handleHeaderClick(ev) {
  const { parentElement } = ev.target
  const { classList, className } = parentElement
  const questions = document.querySelectorAll('.question.current')

  if (!classList.contains('current')) {
    questions.forEach(el => el.classList.remove('current'))
    classList.add('current')
  } else if (classList.contains('completed') && !classList.contains('current')) {
    questions.forEach(el => el.classList.remove('current'))
    classList.add('current')
  } else if (classList.contains('current')) {
    if (parentElement.querySelectorAll('input:checked').length) classList.add('completed')
    classList.remove('current')
  }
}

function handleAnswerChange(ev) {
  const { name, checked, type, dataset } = ev.target
  const question = findAncestorByClassName(ev.target, 'question')

  if (type === 'radio') {
    if (!answers[name]) remaining--

    answers[name] = [dataset['label']]
  } else if (type === 'checkbox') {
    if (checked) {
      if (!answers[name]?.length) {
        answers[name] = [dataset['label']]
        remaining--
      } else answers[name].push(dataset['label'])
    } else {
      answers[name] = answers[name].filter(e => e !== dataset['label'])
    }
  }
  if (answers[name]?.length) question.classList.add('completed')
  else {
    question.classList.remove('completed')
    remaining++
  }

  question.querySelector('.answer').textContent = answers[name].join(', ')
  document.querySelector('.remaining span').textContent = remaining

  toggleRemainingAnswers(remaining)
}

function setUncompleted() {
  const total = document.querySelector('#total')?.value
  const completed = document.querySelector('#completed')?.value

  if (!total || !completed) return

  const remainingNode = document.querySelector('.remaining')

  remaining = Number(total) - Number(completed)
  remainingNode.querySelector('span').textContent = remaining

  toggleRemainingAnswers(remaining)
}

function toggleRemainingAnswers(show) {
  const remainingNode = document.querySelector('.remaining')

  if (show) {
    remainingNode.classList.remove('hidden')
    if (IB.currentDevice === 'mobile') remainingNode.previousElementSibling.classList.add('pb')
  } else {
    remainingNode.classList.add('hidden')
    if (IB.currentDevice === 'mobile') remainingNode.previousElementSibling.classList.remove('pb')
  }
}

function findAncestorByClassName(element, className) {
  if (!element.parentElement) return null

  if (element.parentElement.classList.contains(className)) return element.parentElement
  return findAncestorByClassName(element.parentElement, className)
}

init()
